import { useRef } from "react";
import type { RefObject } from "react";
import { BrowserRouter, Route, Routes } from "react-router";

import { Toast } from "primereact/toast";

// Toolkit imports
import { CookieConsent } from "sj-ui-toolkit/src/atlas/components";
import { LoginAppRoutes } from "sj-ui-toolkit/src/constants/routes";
import { useSegment } from "sj-ui-toolkit/src/hooks";

// Route components
import ForgotPasswordPage from "./components/ForgotPassword/ForgotPasswordPage";
import LoginPage from "./components/Login/LoginPage";
import SamlRedirectPage from "./components/SamlRedirectPage";
import SignedOutPage from "./components/SignedOutPage";
import SignupPage from "./components/Signup/SignupPage";
import SjAdminLoginPage from "./components/SjAdminLoginPage";
import TenantListPage from "./components/TenantList/TenantListPage";
import VerifySignupPage from "./components/VerifySignup/VerifySignupPage";
import SelectTenantPage from "./components/SelectTenant/SelectTenant";
import DeveloperProfilePage from "./components/DeveloperProfile/DeveloperProfilePage";
import NoLicenseAvailable from "./components/NoLicenseAvailable/NoLicenseAvailable";
import Scorm from "./components/Scorm/Scorm";
import { DemoRegistration } from "./components/DemoRegistration/DemoRegistration";

declare global {
  interface Window {
    toast: RefObject<Toast | null>;
  }
}

function App() {
  useSegment();
  const toast = useRef<Toast>(null);
  window.toast = toast;

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <BrowserRouter>
        <CookieConsent />
        <Routes>
          <Route path={LoginAppRoutes.route} element={<LoginPage />} />

          <Route path={LoginAppRoutes.routes.samlRedirect.route} element={<SamlRedirectPage />} />
          <Route path={LoginAppRoutes.routes.register.route} element={<SignupPage />} />
          <Route path={LoginAppRoutes.routes.verify.route} element={<VerifySignupPage />} />
          <Route path={LoginAppRoutes.routes.signedOut.route} element={<SignedOutPage />} />
          <Route
            path={LoginAppRoutes.routes.tenantSelection.route}
            element={<SelectTenantPage />}
          />
          <Route path={LoginAppRoutes.routes.unlicensed.route} element={<NoLicenseAvailable />} />
          <Route
            path={LoginAppRoutes.routes.developerProfile.route}
            element={<DeveloperProfilePage />}
          />
          <Route
            path={LoginAppRoutes.routes.forgotPassword.route}
            element={<ForgotPasswordPage />}
          />
          <Route path={LoginAppRoutes.routes.scorm.route} element={<Scorm />} />

          {/* Registration for assessment demo */}
          <Route path={LoginAppRoutes.routes.demoRegister.route} element={<DemoRegistration />} />

          {/* These two pages simply redirect to the sj-admin app now*/}
          <Route path={LoginAppRoutes.routes.tenantList.route} element={<TenantListPage />} />
          <Route path={LoginAppRoutes.routes.sjAdmin.route} element={<SjAdminLoginPage />} />

          {/* For the login app, just render login - that will take you where you need to go */}
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
